<ejs-grid #grid
          class="grid-with-toolbar grid-no-filter grid-configuration"
          width="100%"
          rowHeight="38"
          [dataSource]="data"
          [allowSorting]="true"
          [allowPaging]="true"
          [allowFiltering]="true"
          [pageSettings]='pageSettings'
          [filterSettings]="filterSettings"
          (rowSelected)="onRowSelected($event)"
          (recordDoubleClick)="onRecordDoubleClick($event)"
          (dataBound)="onDataBound()">
  <e-columns>
    <e-column field="id"
              [visible]="false"
              [isPrimaryKey]="true"></e-column>
    <e-column field="templateName"
              headerText="{{'i18n.domain.export-configuration.shared.column-headers.template' | translate}}"
              clipMode="EllipsisWithTooltip">  
    </e-column>
    <e-column field="configurationType"
        headerText="{{'i18n.shared.configuration-type' | translate}}"
        clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{getTypeName(data.configurationType) | translate}}
        </ng-template>
      </e-column>
  </e-columns>
</ejs-grid>